import { useEffect } from 'react'
import { autorun, runInAction } from 'mobx'
import storeFormat from 'GlobalStores/Format/StoreFormat'

import StoreReferralCart from '../Stores/StoreReferralCart'
import StoreReferralProducts from '../Stores/StoreReferralProducts'
import StoreAddEditProduct from '../Stores/StoreAddEditProduct'
import { cartRowsFromSession, parseSessionItems } from '../Helpers/addonHelpers'

// The cart is memory-only, so every page that can be reached by a reload has to rebuild it from the
// Hydra session before the customer can act on it — the payment page to show the order, the
// create-account form because Continue posts the cart as the new session's items (an empty cart there
// would create a session with `items: "[]"`).
//
// Both the session and the published catalogues are needed and they land in either order, which is why
// this waits inside an autorun instead of running on mount. It only ever fills an empty cart, so it can
// never overwrite what the customer is doing.
export const useRestoreCartFromSession = () => {
    useEffect(() => {
        const disposer = autorun(self => {
            const sessionItems = parseSessionItems(storeFormat.GetDetailPage())
            const packProducts = StoreReferralProducts.GetProducts()
            const addonProducts = StoreAddEditProduct.Catalog()

            if (sessionItems.length === 0 || (packProducts.length === 0 && addonProducts.length === 0)) {
                return
            }

            self.dispose()

            if (StoreReferralCart.items.length > 0) {
                return
            }

            const rows = cartRowsFromSession(sessionItems, packProducts, addonProducts)
            if (rows.length > 0) {
                runInAction(() => StoreReferralCart.ReplaceItems(rows))
            }
        })

        return () => disposer()
    }, [])
}
